module.exports = __webpack_public_path__ + "img/cylinder.0582c864.svg";